/**
 * Testimonials carousel (Swiper). Active when section has more than 3 blocks.
 */
function initTestimonialsCarousels(root) {
  const scope = root || document;

  if (typeof Swiper === 'undefined') return;

  scope.querySelectorAll('[data-testimonials-carousel][data-enable-carousel="true"]').forEach((container) => {
    const swiperEl = container.querySelector('.testimonials-swiper');
    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slidesPerViewDesktop = parseInt(container.dataset.slidesDesktop, 10) || 3;
    const slidesPerViewMobile = parseInt(container.dataset.slidesMobile, 10) || 1;
    const spaceBetween = parseInt(container.dataset.spaceBetween, 10) || 20;
    const enableLoop = container.dataset.enableLoop === 'true';

    new Swiper(swiperEl, {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetween,
      slidesPerGroup: 1,
      loop: enableLoop,
      watchOverflow: true,
      navigation: {
        nextEl: container.querySelector('[data-carousel-next]'),
        prevEl: container.querySelector('[data-carousel-prev]'),
      },
      breakpoints: {
        750: {
          slidesPerView: slidesPerViewDesktop,
          slidesPerGroup: 1,
        },
      },
    });
  });
}

function initTestimonialsWhenReady(root, attempts) {
  if (typeof Swiper !== 'undefined') {
    initTestimonialsCarousels(root);
    return;
  }

  if ((attempts || 0) < 40) {
    window.setTimeout(() => initTestimonialsWhenReady(root, (attempts || 0) + 1), 50);
  }
}

document.addEventListener('DOMContentLoaded', () => initTestimonialsWhenReady());
document.addEventListener('shopify:section:load', (event) => initTestimonialsWhenReady(event.target));
